import React, { Component } from 'react'
import Home from '../Home/Home'

export default class PatientStatus extends Component {
    state = {}

    render() {
        return (
            <React.Fragment>
                <div className="flex flex-col md:flex-row items-center justify-center m-10">
                    <div>
                        <h1 className="text-2xl">
                            This patient questionnaire is not available for you.
                        </h1>
                    </div>
                </div>
                <Home />
            </React.Fragment>
        )
    }
}
